import { ContextualContentBox } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

export const InsufficientDataMessage = () => {
    const { t } = useTranslation();

    return (
        <ContextualContentBox size="small">
            <Typography variant="body1">
                {t(
                    "action_plan.insufficient_data_message",
                    "The data provided in the questionnaire is insufficient to verify some of the actions.",
                )}
            </Typography>
        </ContextualContentBox>
    );
};
